import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d7ddb998&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ddb998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7ddb998')) {
      api.createRecord('d7ddb998', component.options)
    } else {
      api.reload('d7ddb998', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d7ddb998&scoped=true&", function () {
      api.rerender('d7ddb998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oICB6BKEZJ4t/JS/comp/Accordion.vue"
export default component.exports